import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../../Navbar";
import Sidebar from "../../../Sidebar";
import {
  deleteCustomer,
  listAllCustomersPageable,
  listAllCustomersByPage,
  findCustomerByNameOrPhone,
} from "../../../services/CustomerService";
import { CDBTable, CDBTableHeader, CDBSpinner, CDBTableBody } from "cdbreact";
import ClienteForm from "./modal/AdicionarClienteForm";
import EditarClienteModal from "./modal/EditarClienteModal";
import PaginationBootstrap from "../../../components/PaginationBootstrap";
import { toast } from "react-toastify";
import { maskPhone } from "../../../util/StringUtils";
import HistoricoCliente from "./modal/HistoricoCliente";

export const Clientes = () => {
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState({});
  const [toggled, setToggled] = useState(false);
  const [customer, setCustomer] = useState();
  const [historyOpen, setHistoryOpen] = useState(false);
  const filterNameOrPhone = useRef("");

  useEffect(() => {
    window.scrollTo(0, 0);
    handleSidebarToggle();
    listCustomers();
  }, []);

  function listCustomers(delay) {
    setIsLoading(true);
    listAllCustomersPageable(delay)
      .then((response) => {
        setCustomers(response.data);
        setPageInfo(response.pageInfo);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  function listCustomersByPage(pageNumber) {
    listAllCustomersByPage(pageNumber)
      .then((response) => {
        setCustomers(response.data);
        setPageInfo(response.pageInfo);
      })
      .catch((error) => { });
  }

  function removeCustomer(customerId) {
    const execute = window.confirm(
      "Tem certeza que deseja remover este cliente?"
    );

    if (execute) {
      deleteCustomer(customerId)
        .then((response) => {
          toast.success(response);
          listCustomers(false);
        })
        .catch((error) => {
          console.log(error);
          toast.error("Não foi possivel remover este cliente");
        });
    }
  }

  function handleSidebarToggle() {
    const isMobile = window.innerWidth <= 720;
    if (isMobile) {
      setToggled(true);
    }
  }

  function handleClickHistory(customer) {
    setCustomer(customer);
    setHistoryOpen(true);
  }

  function handleClickClearFilter() {
    listCustomers();
    filterNameOrPhone.current.value = "";
  }

  function findCustomer() {
    setIsLoading(true);
    findCustomerByNameOrPhone(filterNameOrPhone.current.value)
      .then((response) => {
        setCustomers(response.data);
        setPageInfo(response.pageInfo);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  return (
    <div className="d-flex">
      <div>
        <Sidebar toggled={toggled} />
      </div>
      <div className="main-content-wrapper">
        <Navbar toggled={toggled} setToggled={setToggled} />
        <div style={{ height: "100%" }}>
          <div
            style={{
              padding: "20px 5%",
            }}
          >
            <div>
              <div className="mt-3">
                <div className="d-flex justify-content-between">
                  <h3 className="fw-bold text-dark">Clientes</h3>
                </div>

                <div className="d-flex mt-3 mb-1">
                  <div>
                    <ClienteForm listCustomers={listCustomers} />

                    {historyOpen && (
                      <HistoricoCliente
                        historyOpen={historyOpen}
                        setHistoryOpen={setHistoryOpen}
                        customer={customer}
                      />
                    )}
                  </div>
                  <div className="vertical-line me-1"></div>
                  <div>
                    <button
                      className="btn btn-primary fw-bold d-flex align-items-center"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseExample"
                      aria-expanded="false"
                      aria-controls="collapseExample"
                    >
                      <i className="fa fa-filter me-2"></i>
                      Filtrar
                    </button>
                  </div>
                </div>

                <div className="mt-3 mb-3">
                  <div className="collapse" id="collapseExample">
                    <div className="card card-body">
                      <div>
                        <input
                          ref={filterNameOrPhone}
                          className="form-control"
                          placeholder="Filtrar por nome ou telefone do cliente"
                        />
                      </div>
                      <div className="mt-3">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={findCustomer}
                          disabled={!filterNameOrPhone}
                        >
                          {" "}
                          <i
                            className="fa fa-search me-2"
                            aria-hidden="true"
                          ></i>
                          Pesquisar
                        </button>

                        <button
                          className="btn mx-3"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseExample"
                          onClick={handleClickClearFilter}
                        >
                          <i className="fa fa-times me-2"></i>
                          Limpar filtros
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {isLoading ? (
                  <div className="d-flex justify-content-center p-3">
                    <CDBSpinner dark />
                  </div>
                ) : (
                  <div>
                    <CDBTable className="alcon-table" responsiveSm borderless>
                      <thead>
                        <tr>
                          <th>Cliente</th>
                          <th>Contato</th>
                          <th className="text-center">Notificar</th>
                          <th>Endereço</th>
                          <th className="text-end">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customers && customers.map((customer) => (
                          <tr key={customer.id}>
                            {/* Nome com destaque */}
                            <td className="fw-bold text-dark">{customer.name}</td>

                            {/* Telefone com ícone discreto */}
                            <td className="text-muted">
                              <i className="fab fa-whatsapp me-1 text-success small"></i>
                              {maskPhone(customer.phone.substring(2))}
                            </td>

                            {/* Notificar com Badge colorida (Verde/Cinza) */}
                            <td className="text-center">
                              <span className={`badge rounded-pill ${customer.notify ? 'bg-success-subtle text-success' : 'bg-light text-muted border'}`} style={{ fontSize: '0.75rem' }}>
                                {customer.notify ? "ATIVO" : "OFF"}
                              </span>
                            </td>

                            {/* Endereço com limite de largura para não quebrar o layout */}
                            <td className="small text-truncate" style={{ maxWidth: '150px' }}>
                              {customer.address || "---"}
                            </td>

                            {/* Ações agrupadas (Dropdown Estilo App) */}
                            <td className="text-end">
                              <div className="dropdown position-static">
                                <button
                                  className="btn btn-link btn-3-dots text-muted shadow-none p-0"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  data-bs-display="static"
                                >
                                  <i className="fas fa-ellipsis-v"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-3">
                                  <li>
                                    <EditarClienteModal
                                      listCustomers={listCustomers}
                                      customer={customer}
                                    />
                                  </li>
                                   <li><hr className="dropdown-divider" /></li>
                                  <li>
                                    <button
                                      onClick={() => handleClickHistory(customer)}
                                      className="dropdown-item py-2 d-flex align-items-center"
                                    >
                                      Histórico do Cliente
                                    </button>
                                  </li>
                                  <li><hr className="dropdown-divider" /></li>
                                  <li>
                                    <button
                                      onClick={() => removeCustomer(customer.id)}
                                      className="dropdown-item py-2 d-flex align-items-center text-danger"
                                    >
                                      Excluir
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </CDBTable>
                    <div>
                      {customers.length > 0 ? (
                        <PaginationBootstrap
                          pageInfo={pageInfo}
                          goToPage={listCustomersByPage}
                        />
                      ) : (
                        <>Nenhum cliente cadastrado.</>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Clientes;
